import ls from 'local-storage'
import {mapGetters} from 'vuex'

function isLoggedIn () {
  const user = ls.get('user')
  if (user) {
    const token = user.token
    return token
  }
  return null
}

function hasUserInfo () {
  const user = ls.get('user')
  if (user) {
    return user
  }
  return null
}

function hasActiveLocation () {
  const location = ls.get('location')
  if (location) {
    let curDate = new Date()
    let setLocationDate = new Date(location.setDate)
    let timeDiff = Math.abs(setLocationDate.getTime() - curDate.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    if (diffDays >= 7) {
      return null
    }

    return location
  }

  return null
}

function hasCart () {
  const cart = ls.get('cart')

  if (cart) {
    let curDate = new Date()
    let setDate = new Date(cart.setDate)
    let timeDiff = Math.abs(setDate.getTime() - curDate.getTime())
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

    if (diffDays >= 7) {
      return []
    }

    return cart
  }

  return []
}

export default {
  computed: {
    ...mapGetters([
      'getOrderType'
    ])
  },
  token: isLoggedIn(),
  user: hasUserInfo(),
  location: hasActiveLocation(),
  topError: null,
  isLoading: false,
  deliveryCost: 0,
  adminFee: 0,
  discountThreshold: 0,
  minimumForDelivery: 0,
  websiteAvailability: {
    isOpen: true,
    nextOpeningHour: null,
    nextOpeningDay: null,
    canTakeOrders: true,
    canDoDelivery: false
  },
  websiteContacts: {
    email: null,
    phone: null,
    address: null
  },
  socials: {
    facebook: null,
    instagram: null,
    twitter: null,
    youtube: null
  },
  cart: hasCart(),
  discount: {
    code: null,
    amount: null,
    type: null
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js